import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisRequest = ApiDefinition['/ai/price-description']['POST'];
type Input = ThisRequest['body'];
type Output = ThisRequest['response'];

const generatePriceDescription = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/ai/price-description', payload);
  return response.data;
};

export default generatePriceDescription;